export default {"src":"/_next/static/media/rePay.39a82195.svg","height":120,"width":121};